module.exports = __webpack_public_path__ + "static/media/illustration-principles.3cc3c8e1.svg";